module.exports = __webpack_public_path__ + "media/images/strava-badge-white-a3a1cb97.svg";